// src/components/ui/DisplayCard.jsx
// Tarjeta de linea de tiempo estilo "chrono board": punto de estado
// conectado por una linea vertical + tarjeta de contenido que se
// resalta cuando esta activa. Adaptado del componente de referencia a
// las convenciones de este proyecto (CRA + JS + Tailwind, sin shadcn/TS,
// sin alias "@/") y con soporte real de tema claro/oscuro en vez del
// tema oscuro fijo del original.
import React from 'react';

const cn = (...inputs) => inputs.filter(Boolean).join(' ');

export function DisplayCard({
  icon,
  title,
  description,
  date,
  status,
  statusClassName,
  active = false,
  onToggle,
  actions,
  children,
}) {
  return (
    <div className="group relative flex items-start gap-x-4">
      {/* Linea vertical que conecta los puntos */}
      <div className="absolute left-[11px] top-6 h-[calc(100%-8px)] w-0.5 bg-gray-200 dark:bg-gray-700 last:hidden" />

      {/* Punto de estado */}
      <button
        type="button"
        onClick={onToggle}
        className={cn(
          'relative z-10 mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full transition-colors',
          active
            ? 'bg-blue-600 ring-4 ring-blue-100 dark:ring-blue-900/30'
            : 'bg-gray-200 dark:bg-gray-700 group-hover:bg-gray-300 dark:group-hover:bg-gray-600'
        )}
        title={onToggle ? 'Marcar como completado' : undefined}
      >
        {icon ? (
          React.cloneElement(icon, {
            className: cn('h-3.5 w-3.5', active ? 'text-white' : 'text-gray-500 dark:text-gray-400'),
          })
        ) : (
          <div className={cn('h-2 w-2 rounded-full', active ? 'bg-white' : 'bg-gray-400 dark:bg-gray-500')} />
        )}
      </button>

      {/* Tarjeta de contenido */}
      <div
        className={cn(
          'flex-grow rounded-xl border p-4 transition-all duration-200',
          active
            ? 'border-blue-200 dark:border-blue-900/40 bg-blue-50/60 dark:bg-blue-900/10 shadow-sm'
            : 'border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-700/30'
        )}
      >
        <div className="flex items-center justify-between gap-3">
          <p className="font-semibold text-gray-900 dark:text-white">{title}</p>
          {date && <span className="shrink-0 text-xs text-gray-400 dark:text-gray-500">{date}</span>}
        </div>
        {description && <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{description}</p>}
        {children}
        {(status || actions) && (
          <div className="mt-3 flex items-center justify-between">
            {status && (
              <span className={cn('rounded-full px-2 py-0.5 text-xs font-medium', statusClassName)}>
                {status}
              </span>
            )}
            {actions && <div className="flex items-center gap-2">{actions}</div>}
          </div>
        )}
      </div>
    </div>
  );
}

export function DisplayCards({ cards }) {
  return (
    <div className="relative w-full space-y-5">
      {cards.map((cardProps, index) => (
        <DisplayCard key={cardProps.id ?? index} {...cardProps} />
      ))}
    </div>
  );
}
